import win1 from '../images/winter/QA1A8484.jpg'
import win2 from '../images/winter/QA1A4645.jpg'
import win3 from '../images/winter/QA1A4044.jpg'
import win4 from '../images/winter/QA1A2457.jpg'
import win5 from '../images/winter/QA1A8413.jpg'
import win6 from '../images/winter/EV2A3202.jpg'
import win7 from '../images/winter/EV2A2762.jpg'
import win8 from '../images/winter/QA1A8588.jpg'

export const winterData = [
  {
    id: 1,
    image: win1,
    alignment: 'horizontal',
    alt: 'Winter image 1 Jari Sokka'
  },
  {
    id: 2,
    image: win2,
    alignment: 'horizontal',
    alt: 'Winter image 2 Jari Sokka'
  },
  {
    id: 3,
    image: win3,
    alignment: 'horizontal',
    alt: 'Winter image 3 Jari Sokka'
  },
  {
    id: 4,
    image: win4,
    alignment: 'horizontal',
    alt: 'Winter image 4 Jari Sokka'
  },
  {
    id: 5,
    image: win5,
    alignment: 'horizontal',
    alt: 'Winter image 5 Jari Sokka'
  },
  {
    id: 6,
    image: win6,
    alignment: 'horizontal',
    alt: 'Winter image 6 Jari Sokka'
  },
  {
    id: 7,
    image: win7,
    alignment: 'horizontal',
    alt: 'Winter image 7 Jari Sokka'
  },
  {
    id: 8,
    image: win8,
    alignment: 'horizontal',
    alt: 'Winter image 8 Jari Sokka'
  }
]